import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { cookie } from 'utils/cookies/index';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { IconUser, IconLogout } from '@tabler/icons-react';
import Avatar from 'components/general/Avatar';
import './Header.scss';

const Header = (props) => {
  const { title = '' } = props;
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const onClickRemove = useCallback(() => {
    cookie.clean();
    window.location.href = '/login';
  }, []);

  const {
    user: { user },
  } = useSelector((state) => state.auth);

  return (
    <>
      <header className="navbar navbar-expand-md sticky-top d-none d-lg-flex d-print-none premium-header">
        <div className="container-xl align-items-center d-flex justify-content-between">
          <div>
            <h2 className="page-title m-0">{title}</h2>
          </div>
          <div className="navbar-nav flex-row align-items-center gap-3">
            {/* User Details */}
            <div className="d-flex align-items-center gap-2 me-2">
              <Avatar className="avatar avatar-sm" role={user?.role} name={`${user?.name} ${user?.lastName ? user?.lastName : ''}`} />
              <div className="d-none d-xl-flex flex-column align-items-start justify-content-center">
                <div className="admin_name">
                  {user?.name}
                  {user?.lastName && ' ' + user?.lastName}
                </div>
                <div className="user_role">
                  {user?.role}
                </div>
              </div>
            </div>

            {/* Direct Action Buttons */}
            <Link 
              to="/profile" 
              className="btn btn-outline-primary d-flex align-items-center gap-2 px-3 py-1.5 border-0 shadow-sm"
              style={{ borderRadius: '8px', fontWeight: '600', background: 'rgba(79, 172, 254, 0.08)', color: '#0ea5e9' }}
              aria-label="Profile"
            >
              <IconUser size={18} />
            </Link>

            <Button 
              variant="outline-danger" 
              className="d-flex align-items-center gap-2 px-3 py-1.5 border-0 shadow-sm"
              style={{ borderRadius: '8px', fontWeight: '600', background: 'rgba(239, 68, 68, 0.08)', color: '#ef4444' }}
              onClick={() => setShowLogoutConfirm(true)}
              aria-label="Logout"
            >
              <IconLogout size={18} />
            </Button>
          </div>
        </div>
      </header>

      {/* Logout Confirmation Modal */}
      <Modal 
        show={showLogoutConfirm} 
        onHide={() => setShowLogoutConfirm(false)} 
        centered
        dialogClassName="logout-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold text-dark d-flex align-items-center gap-2">
            <IconLogout size={24} className="text-danger" />
            Confirm Logout
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3">
          <p className="m-0 text-muted" style={{ fontSize: '1rem', lineHeight: '1.5' }}>
            Are you sure you want to log out of <strong>SiteSync</strong>? Any unsaved form modifications may be lost.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button 
            variant="light" 
            onClick={() => setShowLogoutConfirm(false)}
            style={{ borderRadius: '8px', fontWeight: '600' }}
          >
            Cancel
          </Button>
          <Button 
            variant="danger" 
            onClick={onClickRemove}
            style={{ borderRadius: '8px', fontWeight: '600', background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', border: 'none' }}
          >
            Yes, Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

Header.propTypes = {
  title: PropTypes.string,
};

export default Header;
